//@flow
import React from "react"
import { Field, reduxForm } from "redux-form"
import { InputField, Label, FormGroup } from "../UI/Form"
import { PrimaryButton } from "../UI/Buttons"
import { validate, asyncValidate } from "./validations"

const SignupForm = ({ handleSubmit }) =>
  <form onSubmit={handleSubmit}>
    <FormGroup>
      <Label htmlFor="name">Name</Label>
      <Field name="name" component={InputField} type="text" />
    </FormGroup>
    <FormGroup>
      <Label htmlFor="email">Email</Label>
      <Field name="email" component={InputField} type="email" />
    </FormGroup>
    <FormGroup>
      <Label htmlFor="password">Password</Label>
      <Field name="password" component={InputField} type="password" />
    </FormGroup>
    <PrimaryButton type="submit" block={true}>
      Create Account
    </PrimaryButton>
  </form>

export default reduxForm({
  form: "signup",
  validate: validate({ includePassword: true }),
  asyncValidate,
  asyncBlurFields: ["email"]
})(SignupForm)



// WEBPACK FOOTER //
// ./src/PublicArea/SignupForm.js